// extracted by mini-css-extract-plugin
export default {"modalHeader":"ModalHeader_modalHeader__K+ZmG","title":"ModalHeader_title__-ILXH","closeButton":"ModalHeader_closeButton__yUuk1"};